import { Component, OnInit } from '@angular/core';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';

@Component({
    selector: 'app-avoid-country',
    templateUrl: './avoid-country.component.html',
    styleUrls: ['./avoid-country.component.scss'],
    standalone: false
})
export class AvoidCountryComponent implements OnInit {
  constructor(public flightPlanService: FlightPlanService) { }

  public ngOnInit() {
    this.flightPlanService.atcRouteDetails.AvoidedFir = [];
    this.flightPlanService.atcRouteDetails.AvoidedCountry = [];
  }

  public openAccordian() {
    this.flightPlanService.accordionSwitch('flightplanavoid');
  }

  public removestation(data: string, type: string) {
    if (type == "fir") {
      const index: number = this.flightPlanService.atcRouteDetails.AvoidedFir.indexOf(data);
      if (index > -1) {
        this.flightPlanService.atcRouteDetails.AvoidedFir.splice(index, 1);
      } else {
        this.flightPlanService.atcRouteDetails.AvoidedFir.push(data);
      }
    } else if (type == "Count") {
      const index: number = this.flightPlanService.atcRouteDetails.AvoidedCountry.indexOf(data);
      if (index > -1) {
        this.flightPlanService.atcRouteDetails.AvoidedCountry.splice(index, 1);
      } else {
        this.flightPlanService.atcRouteDetails.AvoidedCountry.push(data);
      }
    } else if (type == "waypoints") {
      const index: number = this.flightPlanService.atcRouteDetails.AvoidedWaypoints.indexOf(data);
      if (index == -1) {
        this.flightPlanService.atcRouteDetails.AvoidedWaypoints.push(data);
      } else {
        this.flightPlanService.atcRouteDetails.AvoidedWaypoints.push(data);
      }
    }
  }
}
